import { getContent } from '@ynap/content-state'

import {
    EIPServiceMessageKey,
    ServiceMessageKey,
    ServiceMessageContentType,
} from 'app/components/ServiceMessage/ServiceMessage'

type GetServiceMessage = {
    content: ServiceMessageContentType | undefined
    isFetchingContent: boolean | undefined
    fetchContentError: boolean | undefined
}

export const getServiceMessage = (state: any, props: { isEip?: boolean }): GetServiceMessage => {
    const { isEip } = props

    const contentKey = isEip ? EIPServiceMessageKey : ServiceMessageKey

    return {
        content: getContent(state, contentKey),
        isFetchingContent: state.content[contentKey]?.loading,
        fetchContentError: state.content[contentKey]?.error,
    }
}

export default getServiceMessage;
